<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
const props = defineProps({
  interestId: { type: [Number, String], default: '' },
  publicationType: { type: String, default: '' },
  entrypoint: { type: String, default: 'PRICE_ACTIONS' },
  loading: { type: Boolean, default: false },
  unavailable: { type: Boolean, default: false },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  if (props.loading) return;
  emit('click', {
    interestId: props.interestId,
    entrypoint: props.entrypoint,
    publicationType: props.publicationType,
    unavailable: props.unavailable,
  });
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <button
    type="button"
    class="inline-flex min-h-9 items-center justify-center gap-2 rounded-lais border px-3 py-2 text-[12px] font-semibold transition disabled:cursor-wait disabled:opacity-70"
    :class="
      unavailable
        ? 'border-amber-200 bg-[#fff8e1] text-amber-800 hover:border-amber-300'
        : 'border-lais-primary-100 bg-lais-primary-50 text-lais-primary hover:border-lais-primary'
    "
    :disabled="loading"
    @click="handleClick"
  >
    <span
      class="size-4"
      :class="
        loading ? 'i-lucide-loader-circle animate-spin' : 'i-lucide-bar-chart-3'
      "
      aria-hidden="true"
    />
    <span>{{ loading ? 'Abrindo...' : 'Ver relatório de preço' }}</span>
  </button>
</template>
